/**  Deprecated in 1.4 */

import * as React from "react";
import appstate from "../../appstate";

import "./promotionBar.scss";

interface IPromotionBarProps {
    code: string,
    onDisableCode: () => void,
    style?: React.CSSProperties
}

interface IPromotionBarState {
}

export class PromotionBar extends React.Component<IPromotionBarProps, IPromotionBarState> {

    constructor (props: IPromotionBarProps) {
        super(props);

        this.props = props;

        this.state = {

        }
    }
    
    render() {

        if (this.props.code == null || this.props.code.length === 0)
            return null;

        if (appstate.modifyConfirmationNumber != null && appstate.modifyConfirmationNumber.length > 0)
            return null;

        return <div className="ncb-promotionBar" style={this.props.style}>
            {NCB.I18n.T.PROMOTION_CODE}: {this.props.code} <span onClick={this.props.onDisableCode}>{NCB.I18n.T.COMMON_REMOVE}</span>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/promotionBar.tsx